import { useTranslator } from '@gandi/translate';
import { Heading } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "NextStepHeader-root_XK7q2"
};
export function NextStepHeader({
  content
}) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h2",
      children: __('Next step')
    }), /*#__PURE__*/_jsx("span", {
      children: content
    })]
  });
}